export enum Sex {
  STALLION = 'stallion',
  MARE = 'mare',
}

export enum HorseActionSuccessTypeEnum {
  HORSE_ADDED,
  HORSE_REMOVED,
  HORSE_UPDATED,
  HORSE_NAME_UPDATED,
  HORSE_CLONED,
  HORSE_BATCH_STOP_SHARE,
  HORSE_MERGED,
  HORSES_BATCH_DELETED,
  HORSES_BATCH_CLONED,
}
